import React, { Component } from 'react';

class Info extends Component {
	render() {
		return (
			<div>
				<h3>This is the component Info!</h3>
				<p>React is awesome!</p>
			</div>
		);
	}
}

export default Info;
